import React, {Component, Fragment, useCallback, useState} from 'react';
import {Row, Col, Collapse} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronCircleDown, faChevronCircleUp} from '@fortawesome/pro-light-svg-icons';
import {faAngleDown} from '@fortawesome/pro-regular-svg-icons/faAngleDown';
import {faAngleUp} from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import {modules, modulesV1, modulesAd} from 'data/module.json';
import IconList, {IconListItem, ListIcon} from 'components/Elements/IconList';
import classNames from 'classnames';
import './ModuleAccordion.scss';
import {ImgBulletCard} from 'components/Elements/ImgBullet';

export default function ModuleAccordion(props) {
  const [activeCards, setActiveCards] = React.useState([0]);
  const onClick = React.useCallback(
    (key) => () => setActiveCards((state) => (state.includes(key) ? state.filter((e) => e !== key) : [...state, key])),
    []
  );
  return modules.map((module, index) => {
    return (
      <div className="module-item" key={index}>
        <div className="module-item-header d-flex align-items-center justify-content-between" onClick={onClick(index)}>
          <div className="module-item-header-text">
            <Row className="bonus-heading d-flex align-items-center justify-content-start m-0">
              <Col xs="12" md="3" lg="2" className="text-center mb-3 mb-md-0 pl-lg-0">
                <img className="module-img" src={module.thumb} />
              </Col>
              <Col xs="12" md="9" lg="10">
                <div className="module-item-count">{module.module}</div>
                <div className="module-item-title">{module.name}</div>
              </Col>
            </Row>
          </div>
          <div className="module-item-header-icon d-flex align-items-center justify-content-end flex-column flex-lg-row">
            <FontAwesomeIcon
              className="module-item-icon mb-1 mb-lg-0 mr-lg-1"
              icon={activeCards.includes(index) ? faChevronCircleUp : faChevronCircleDown}
            />
            <div className="module-item-header-icon-text text-small text-uppercase">
              {activeCards.includes(index) ? (
                <>Close</>
              ) : (
                <>
                  <span className="d-none d-lg-inline">Learn</span> More
                </>
              )}
            </div>
          </div>
        </div>
        <Collapse isOpen={activeCards.includes(index)}>
          <div className="module-item-content">
            <ReactMarkdown className="module-item-description" source={module.description || 'description'} />

            <h5>Discover</h5>
            <IconList>
              {modules[index].discover.map((discover) => (
                <IconListItem>
                  <ReactMarkdown className="module-item-lessons" source={discover || 'list-item'} />
                </IconListItem>
              ))}
            </IconList>

            <h5>Module lessons:</h5>
            <IconList iconColor="purple" className="icon-list-number">
              {modules[index].lessons.map((lessons, i) => (
                <IconListItem number={i + 1}>
                  <ReactMarkdown className="module-item-lessons" source={lessons || 'list-item'} />
                </IconListItem>
              ))}
            </IconList>
          </div>
        </Collapse>
      </div>
    );
  });
}

export function ModuleAccordionV1({modulelist = modulesV1, ...props}) {
  const [activeCards, setActiveCards] = React.useState([0]);
  const onClick = React.useCallback(
    (key) => () => setActiveCards((state) => (state.includes(key) ? state.filter((e) => e !== key) : [...state, key])),
    []
  );
  return modulelist.map((module, index) => {
    return (
      <div className="module-item" key={index}>
        <div className="module-item-header d-flex align-items-center justify-content-between" onClick={onClick(index)}>
          <div className="module-item-header-text">
            <Row className="bonus-heading d-flex align-items-center justify-content-start m-0">
              <Col xs="12" md="3" lg="2" className="text-center mb-3 mb-md-0 pl-lg-0">
                <img className="module-img" src={module.thumb} />
              </Col>
              <Col xs="12" md="9" lg="10">
                <div className="module-item-count">{module.module}</div>
                <div className="module-item-title">{module.name}</div>
              </Col>
            </Row>
          </div>
          <div className="module-item-header-icon d-flex align-items-center justify-content-end flex-column flex-lg-row">
            <FontAwesomeIcon
              className="module-item-icon mb-1 mb-lg-0 mr-lg-1"
              icon={activeCards.includes(index) ? faChevronCircleUp : faChevronCircleDown}
            />
            <div className="module-item-header-icon-text text-small text-uppercase">
              {activeCards.includes(index) ? (
                <>Close</>
              ) : (
                <>
                  <span className="d-none d-lg-inline">Learn</span> More
                </>
              )}
            </div>
          </div>
        </div>
        <Collapse isOpen={activeCards.includes(index)}>
          <div className="module-item-content">
            <ReactMarkdown className="module-item-description" source={module.description || 'description'} />

            {modulelist === modulesAd ? null : <h5>Discover</h5>}
            <IconList>
              {modulelist[index].discover.map((discover) => (
                <IconListItem>
                  <ReactMarkdown className="module-item-lessons" source={discover || 'list-item'} />
                </IconListItem>
              ))}
            </IconList>

            <h5>Module lessons:</h5>
            <Row className="justify-content-center justify-content-lg-start align-items-stretch">
              {modulelist[index].lessons.map((lessons, i) => (
                <Col xs="10" sm="6" lg="3" className="d-flex flex-column">
                  <div className="lesson-item card border-0 box-shadow-black-25 mb-4 h-100">
                    <img className="rounded-top" src={lessons.lessonImage} />
                    <ReactMarkdown
                      className="module-item-lessons px-2 py-3 text-center text-small my-auto"
                      source={lessons.lessonTitle || 'list-item'}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Collapse>
      </div>
    );
  });
}

export function ModuleAccordionNew(props) {
  const [activeCards, setActiveCards] = React.useState([]);
  const onClick = React.useCallback(
    (key) => () => setActiveCards((state) => (state.includes(key) ? state.filter((e) => e !== key) : [...state, key])),
    []
  );
  return modules.map((module, index) => {
    return (
      <div className="module-item module-item-black" key={index}>
        <div className="module-item-header d-flex align-items-center justify-content-between" onClick={onClick(index)}>
          <div className="module-item-header-text">
            <Row className="module-heading d-flex align-items-center justify-content-start m-0">
              <Col xs="12" md="3" lg="2" className="text-center mb-3 mb-md-0 pl-lg-0">
                <img className="module-img" src={module.thumb} />
              </Col>
              <Col xs="12" md="9" lg="10">
                <div className="module-item-count">{module.module}</div>
                <div className="module-item-title">{module.name}</div>
              </Col>
            </Row>
          </div>
          <div className="module-item-header-icon d-flex align-items-center justify-content-end flex-column flex-lg-row">
            <FontAwesomeIcon
              className="module-item-icon mb-1 mb-lg-0 mr-lg-1"
              icon={activeCards.includes(index) ? faAngleUp : faAngleDown}
            />
            <div className="module-item-header-icon-text text-small text-uppercase">
              {activeCards.includes(index) ? (
                <>Close</>
              ) : (
                <>
                  <span className="d-none d-lg-inline">Learn</span> More
                </>
              )}
            </div>
          </div>
        </div>
        <Collapse isOpen={activeCards.includes(index)}>
          <div className="module-item-content">
            <ReactMarkdown className="module-item-description" source={module.description || 'description'} />

            <h5>Discover</h5>
            <ListIcon>
              {modules[index].discover.map((discover, i) => (
                <Fragment key={'discover' + i + 1}>
                  <ReactMarkdown className="module-item-lessons" source={discover || 'list-item'} />
                </Fragment>
              ))}
            </ListIcon>

            <h5>Module lessons:</h5>
            <ListIcon iconColor="purple" number>
              {modules[index].lessons.map((lessons, i) => (
                <Fragment key={'lesson' + i + 1}>
                  <ReactMarkdown className="module-item-lessons" source={lessons || 'list-item'} />
                </Fragment>
              ))}
            </ListIcon>
          </div>
        </Collapse>
      </div>
    );
  });
}
